"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.nodeChildrenToHastArray = exports.nodeToHast = exports.elementToHast = void 0;
var util_1 = require("./util");
exports.elementToHast = function (element, config) {
    if (element.nodeType === element.TEXT_NODE) {
        return {
            type: 'text',
            value: element.nodeValue,
        };
    }
    else {
        var tagName = config.deserializeTagName(element.tagName);
        if (!tagName) {
            return null;
        }
        var properties = {};
        for (var i = 0; i < element.attributes.length; i += 1) {
            var attr = element.attributes[i];
            var property = config.deserializeAttribute(tagName, attr.name, attr.nodeValue);
            properties = __assign(__assign({}, properties), property);
        }
        return util_1.compressElementNode({
            type: 'element',
            tagName: tagName,
            properties: properties,
            children: exports.nodeChildrenToHastArray(element, config),
        });
    }
};
exports.nodeToHast = function (node, config) {
    if (node.nodeType === node.TEXT_NODE) {
        return node.nodeValue ? { type: 'text', value: node.nodeValue } : null;
    }
    else if (node.nodeType === node.ELEMENT_NODE) {
        return exports.elementToHast(node, config);
    }
    return null;
};
exports.nodeChildrenToHastArray = function (node, config) {
    var hastNodes = [];
    if (node.hasChildNodes()) {
        for (var i = 0; i < node.childNodes.length; i += 1) {
            var childNode = node.childNodes[i];
            var hastNode = exports.nodeToHast(childNode, config);
            if (hastNode) {
                hastNodes.push(hastNode);
            }
        }
    }
    return hastNodes;
};
